const dataTableRepresentationFuncs = {
	'on-arrow-left': 'unExpandItem',
	'on-enter': 'selectFocusedItem',
	'un-expand-item': 'unExpandItem',
	'on-arrow-down': 'focusOnNextMenuItem',
	'on-arrow-up': 'focusOnPreviousMenuItem',
};
const previousStepsFuncs = {
	'on-blur': 'onInputBlur',
	'on-arrow-right': 'expandItem',
	'on-arrow-left': 'unExpandItem',
	'on-enter': 'selectFocusedItem',
	'un-expand-item': 'unExpandItem',
	'on-arrow-down': 'focusOnNextMenuItem',
	'on-arrow-up': 'focusOnPreviousMenuItem',
};
const fieldParamsFuncs = {
	'on-blur': 'onInputBlur',
	'on-enter': 'selectFocusedItem',
	'on-arrow-down': 'focusOnNextMenuItem',
	'on-arrow-up': 'focusOnPreviousMenuItem',
};

const processWorkflowPreviousStepsFuncs = {
	'un-expand-item': 'unExpandItem',
};

const DataInputMenuTabsFunctions = {
	fieldParamsFuncs,
	previousStepsFuncs,
	dataTableRepresentationFuncs,
	processWorkflowPreviousStepsFuncs,
};

export default DataInputMenuTabsFunctions;
